import { useSelector } from "react-redux";
import { AuthenticationState } from "../interfaces/users";
import { useMemo } from "react";
import {
  ModulePermission,
  userHasPermission,
} from "../utils/helpers/userHelpers";
import { Regions } from "../modules/Regions";

export const RegionsPage = () => {
  const { user } = useSelector((state: AuthenticationState) => state);
  const hasPermission = useMemo(
    () =>
      userHasPermission(user, {
        region_management: ModulePermission.ADMIN,
      }) ||
      userHasPermission(user, {
        region_management: ModulePermission.USER,
      }) ||
      userHasPermission(user, {
        region_management: ModulePermission.VIEW,
      }),
    [user]
  );

  return hasPermission ? (
    <Regions />
  ) : (
    <div>O seu usuário não possui permissão para acessar este conteúdo</div>
  );
};
